<div class="container">
  <div class="row footer-top py-4">
    <div class="col-md-3 pb-3">
      <h5 class="footer-header">{{ "Home.MainOffice" | translate }}</h5>
      <p class="footer-title">Kenneth Hahn</p>
      <p class="footer-title">Hall of Administration</p>
      <p>500 W. Temple Street, Room 225</p>
      <p>Los Angeles, CA 90012</p>
      <p>(213) 974-3211</p>
      <p class="font-italic">Toll Free Phone:</p>
      <p>1 (888) 807-2111</p>
    </div>
    <div id="border-item" class="col-md-6 border-start border-end pl-md-4">
      <h5 class="footer-header">{{ "Home.DistrictOffices" | translate }}</h5>
      <div class="row">

        <div class="col-12 col-md-4 footer-item">
          <p class="footer-title">North District</p>
          <p>13800 Balboa Boulevard</p>
          <p>Sylmar, CA 91342</p>
          <p>(818) 833-6000</p>
        </div>
        <div class="col-12 col-md-4 footer-item">
          <p class="footer-title">East District</p>
          <p>1190 Durfee Avenue</p>
          <p>South El Monte, CA 91733</p>
          <p>(626) 258-6001</p>
        </div>
        <div class="col-12 col-md-4 footer-item">
          <p class="footer-title">Lancaster Regional</p>
          <p>251 E. Avenue K-6</p>
          <p>Lancaster, CA 93535</p>
          <p>(661) 940-6700</p>
        </div>
        <div class="col-12 col-md-4 footer-item">
          <p class="footer-title ">South District</p>
          <p>1401 E. Willow Street</p>
          <p>Signal Hill, CA 90755</p>
          <p>(562) 256-1701</p>
        </div>
        <div class="col-12 col-md-4 footer-item">
          <p class="footer-title">West Regional</p>
          <!-- <p>Public services are temporarily moved to the Hall of Administration, Room 225. <i>Room 183-19 (mailing address)</i></p> -->
          <p>6167 Bristol Parkway, <br>Suite 100</p>
          <p>Culver City, CA 90230</p>
          <p>(310) 665-5300</p>

        </div>
      </div>
    </div>
    <div class="col-md-3 px-md-4 pl-md-4">
      <h5 class="footer-header">{{ "Home.Connected" | translate }}</h5>
      <div class="row pl-2">
        <span class="footer-social"><a href="https://www.facebook.com/LACAssessor/" target="_blank"><i
          class="fab fa-facebook-square"></i></a></span>
        <span class="footer-social"><a href="https://x.com/lacassessor" target="_blank"><i
          class="fa-brands fa-x-twitter"></i></a></span>
        <span class="footer-social"><a href="https://www.instagram.com/lacassessor/" target="_blank"><i
          class="fab fa-instagram"></i></a></span>
        <span class="footer-social"><a href="https://www.youtube.com/channel/UCEiJxk8Zh_ETjmzFp_eYdVQ"
                                       target="_blank"><i class="fab fa-youtube"></i></a></span>
      </div>
      <div class="row pl-2 pl-md-3 mt-3">
        <button type="button" routerLink="/news-information/newsletters"
                class="footer-btn btn btn-light">{{ "Home.NewsLetter" | translate }} <span><i
          class="fas fa-angle-right"></i></span></button>
      </div>
      <div class="row pl-2 pl-md-3 mt-3">
        <a type="button" style="-webkit-appearance: none; border-radius: 0;" target="_blank"
           href="https://www.governmentjobs.com/careers/lacounty"
           class="footer-btn btn btn-light">{{ "NavMenu.CountyJob" | translate }}<span><i
          class="fas fa-angle-right"></i></span></a>
      </div>
    </div>
  </div>

</div>
<div class="row bottom-footer">
  <p><span><i class="far fa-copyright"></i></span> los angeles county assessor's office. {{ date }}. | <a
    href="https://res.cloudinary.com/los-angeles-county-assessor/raw/upload/v1675364447/Change%20Log/change.log"
    target="_blank" style="text-transform: lowercase;">v2.5.2.0</a> (Last updated 4/18/2025)</p>
  <!-- <p><span><i class="far fa-copyright"></i></span> los angeles county assessor's office. {{date}}. <a href="https://res.cloudinary.com/los-angeles-county-assessor/raw/upload/v1675364447/Change%20Log/change.log" target="_blank" style="text-transform: lowercase;">v2.2.1.1</a> (Last updated 2/1/2023) - QA</p> -->
  <!-- <p><span><i class="far fa-copyright"></i></span> los angeles county assessor's office. {{date}}. <a href="https://res.cloudinary.com/los-angeles-county-assessor/raw/upload/v1675364447/Change%20Log/change.log" target="_blank" style="text-transform: lowercase;">v2.2.1.1</a> (Last updated 2/1/2023) - DEV</p> -->
</div>

